module.exports = __webpack_public_path__ + "img/Image Container.0bdc4987.png";